/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react'

import { LinearIcon } from '@slite/icons'

import type { Scenario } from './types'

const SpinnerIcon = () => (
  <span
    className="spinner-rotating flexbox-no-shrink"
    style={{
      width: 16,
      height: 16,
      borderRadius: 999,
      border: '2px solid var(--shade-40)',
      borderTopColor: 'var(--shade-10)',
    }}
  />
)

const OUTDATED = `# Data Retention Policy

Last reviewed: {-March 2022-} {+June 2026+}

## Purpose
This policy defines how The Nice Co. retains and disposes of data to meet
legal, regulatory, and operational requirements.

## Retention Periods

- **Customer records:** {-90 days-} {+1 year+} (AWS S3, eu-west)
- **Support tickets:** 1 year (Intercom)
- **Employee records:** 5 years (Google Drive)
- **Financial records:** 7 years (NetSuite)
- **Application logs:** 30 days (Datadog)

## Deletion
Data exceeding its retention period is deleted on the 1st of each
month via automated pipeline. Exceptions require VP approval.

## Review Cycle
This policy is reviewed annually by the Legal and Security teams.

## Owner
Legal: legal@acme.com
`

const APPLIED = `# Data Retention Policy

Last reviewed: June 2026

## Purpose
This policy defines how The Nice Co. retains and disposes of data to meet
legal, regulatory, and operational requirements.

## Retention Periods

- **Customer records:** 1 year (AWS S3, eu-west)
- **Support tickets:** 1 year (Intercom)
- **Employee records:** 5 years (Google Drive)
- **Financial records:** 7 years (NetSuite)
- **Application logs:** 30 days (Datadog)

## Deletion
Data exceeding its retention period is deleted on the 1st of each
month via automated pipeline. Exceptions require VP approval.

## Review Cycle
This policy is reviewed annually by the Legal and Security teams.

## Owner
Legal: legal@acme.com
`

export const weeklyScenario: Scenario = {
  id: 'weekly',
  buttonLabel: 'Knowledge base audit',
  initialDocId: 'data-retention-policy',
  signal: { icon: <SpinnerIcon />, label: 'Weekly knowledge base audit' },
  routine: {
    label: 'Scanning knowledge that changed this week',
  },
  sourceSignal: {
    icon: <LinearIcon size={16} />,
    label: 'Linear ticket says customer records now require 1 year retention',
  },
  finding: 'Data Retention Policy conflicts with the latest legal guidance.',
  diff: {
    docId: 'data-retention-policy',
    outdatedContent: OUTDATED,
    appliedContent: APPLIED,
    pill: { kind: 'replace', before: '90 days', after: '1 year' },
  },
  routeNote: 'Included in this week’s audit.',
  reviewer: { name: 'Peter', cursorColor: '#6B5D46' },
}
